import styles from './importedCsvReport.module.css'
import { Button, Column, Icon, Section, Table } from "../../ui"
import { CsvImportResult } from "../types"

interface Props {
    columns: Column[]
    csvImportResult: CsvImportResult
    onNewUpdate: () => void
}

export const ImportedCsvReport = (props: Props) => {
    const { columns, csvImportResult, onNewUpdate } = props

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <Icon icon="check-circle-fill" />
                <span>Las siguientes filas se importaron correctamente.</span>
            </div>
            <Section
                id="imported-rows"
                title="Filas Importadas"
                collapsable
                defaultExpanded
            >
                <Table
                    columns={columns}
                    rows={csvImportResult.importedRows}
                    rowId="rowIndex"
                    readOnly
                />
            </Section>
            <div className={styles.header}>
                <Icon icon="exclamation-circle-fill" color="secondary" />
                <span>Las siguientes filas no se importaron, revisar posibles errores en los valores.</span>
            </div>
            <Section
                id="unimported-rows"
                title="Filas Ignoradas"
                collapsable
                defaultExpanded
            >
                <Table
                    columns={columns}
                    rows={csvImportResult.unimportedRows}
                    rowId="rowIndex"
                    readOnly
                />
            </Section>
            <div className={styles.btn}>
                <Button
                    icon="repeat"
                    label="Nueva Actualización"
                    onClick={onNewUpdate}
                />
            </div>
        </div>
    )
}
